import { Directionality } from '@angular/cdk/bidi';
import {
  Overlay,
  OverlayKeyboardDispatcher,
  OverlayOutsideClickDispatcher,
  OverlayPositionBuilder,
  ScrollStrategyOptions,
} from '@angular/cdk/overlay';
import { DOCUMENT, Location } from '@angular/common';
import { ComponentFactoryResolver, Injectable, Injector, NgZone, inject } from '@angular/core';

import { ContextTooltipOverlayContainer } from './context-tooltip-overlay-container';

@Injectable()
export class ContextTooltipOverlay extends Overlay {
  constructor() {
    const scrollStrategies = inject(ScrollStrategyOptions);
    const _overlayContainer = inject(ContextTooltipOverlayContainer);
    const _componentFactoryResolver = inject(ComponentFactoryResolver);
    const _positionBuilder = inject(OverlayPositionBuilder);
    const _keyboardDispatcher = inject(OverlayKeyboardDispatcher);
    const _injector = inject(Injector);
    const _ngZone = inject(NgZone);
    const _document = inject<Document>(DOCUMENT);
    const _directionality = inject(Directionality);
    const _location = inject(Location);
    const _outsideClickDispatcher = inject(OverlayOutsideClickDispatcher);

    super(
      scrollStrategies,
      _overlayContainer,
      _componentFactoryResolver,
      _positionBuilder,
      _keyboardDispatcher,
      _injector,
      _ngZone,
      _document,
      _directionality,
      _location,
      _outsideClickDispatcher,
    );
  }
}
